const invalidEmail = 'E-post är ogiltigt';

const fi: LocaleType = {
  cancellation: {
    noRefund: 'Non refundable',
    free: 'Free cancellation',
    arrival: (...args: string[]) =>
      `${args[0]} ${parseInt(args[0]) > 1 ? 'days' : 'day'} before arrival`,
  },
  subtitle: (...args: string[]) => `${args[0]} is ${args[1]}`,
  cancel: 'Avbryt',
  update: 'Uppdatera',
  login_button: 'Logga in',
  signout: 'Logga ut',
  menu: 'Menu',
  loading: 'Snälla vänta',
  read_more: 'Läs mer',
  camps: {
    allImagesButton: (...args: string[]) => `All Images (${args[0]})`,
  },
  auth: {
    successAuth: 'Autentiserats. Omdirigera till startsidan',
    processing: 'Bearbeta autentisering',
    invalidAuth: 'Ogiltig session för användaren.',
  },
  errors: {
    default: 'Den här begäran kunde inte levereras',
    duplicate: 'Data finns redan i systemet.',
    invalidEmail: invalidEmail,
    requiredEmail: 'E-postadress är obligatorisk.',
    invalidName: 'Namn är ogiltigt.',
    requiredName: 'Namn är obligatoriskt.',
    invalidDate: 'Ogiltigt datum.',
    requiredDate: 'Datum krävs.',
    disclaimer: 'Du måste godkänna ansvarsfriskrivningen för att fortsätta.',
  },
  cookie: {
    message:
      'Denna webbplats använder cookies för att ge dig en bra användarupplevelse. Genom att fortsätta använda denna webbplats godkänner du användningen av cookies i enlighet med oss.',
    policy: 'Cookiepolicy',
    accept: 'Acceptera',
  },
  landing_page: {
    header: {
      user: {
        hey: (...args: string[]) => `Hej ${args[0]}, `,
        bookings: 'kolla dina egna bokningar här',
        check_bookings: 'Kolla dina bokningar',
        has_reservation: 'Har du redan en reservation? ',
        customer_service: 'Customer Service',
      },
      menus: {
        home: 'Framsida',
        parks: 'Parker',
        our_story: 'Presentation',
        for_host: 'För Värdar',
        the_cities: 'För Städer',
        contact_us: 'Kontakta oss',
        login: 'Logga in',
      },
      buy_tickets: 'Köp biljetter',
      buy: 'Köp',
      all_parks: 'Alla parker',
      make_reservation: 'Boka nu',
      for_host: 'För Värdar',
      demonstration: 'Presentation',
      the_cities: 'För Städer',
      the_press: 'För Pressen',
    },
    footer: {
      follow: 'Fölg oss',
      contact: 'Kontakter',
      quick_links: 'Snabblänkar',
      traveling: 'Resa med dig',
      other_links: 'Andra länkar',
      privacy_statement: 'Dataskyddsförklaring',
      terms_of_delivery: 'Leveransvillkor',
      see_map: 'Se på kartan',
      travel: 'Tillsammans på väg med dig',
      privacy: 'Dataskyddsförklaring',
      media: 'För Pressen',
      phone: 'Customer service',
    },
    hero: {
      title: 'Det bästa sättet att stanna!',
      text: 'Vi öppnar de sex första parkerna för sommarsäsongen 2020.',
      view_parks: 'Ta en titt på parkerna',
    },
  },
  parks_list_page: {
    hero: {
      title: 'Lempäälä',
      text:
        'En modern husvagnspark med bra bekvämligheter precis intill Tammerfors.',
    },
  },
  park_info: {
    header: 'Välj ankomstdatum i kalendern',
    amenities: (...args: string[]) =>
      `${args[0]} platser och ${args[1]} bekvämligheten:`,
    faq: 'Vanliga frågor och svar',
    extras: {
      area: 'Område',
      forWhom: 'För vem',
      thingsToDo: 'Sevärdheter och aktiviteter',
    },
    intro: 'Presentation',
    country: 'Land',
    region: 'Område',
    location: 'Plats',
    night: 'natt',
    show_more: 'Visa mer',
    show_less: 'Visa mindre',
    suitable_for: 'Passande för',
    caravan: 'Husvagn',
    camper_van: 'Camper Van',
    tent: 'Tänt',
    cottages: 'Stugor',
    startsFrom: 'Slot price per natt',
  },
  reservation: {
    noReservation: 'Inga reserveringar',
    continue: 'Forsätta',
    previous: 'Tidigare',
    loading: 'Snälla vänta',
    slots: {
      header: 'Hur många nätter stannar du?',
      arrival: (...args: string[]) => `Ditt ankomstdatum ${args[0]}.`,
      comment: (...args: string[]) =>
        `Eftersom nästa helg är slutsåld kan den maximala natten per vistelse vara ${args[0]}.`,
      choose: '[FI] Select Slot',
      chooseTitle: 'Boka en plats',
      unavailable: '[FI] unavailable',
      price: (...args: string[]) => `(${args[0]}€/natt)`,
      addPrice: (...args: string[]) => `(+${args[0]}€/natt)`,
      summary: (...args: string[]) =>
        `The total cost for this reservation is ${args[0]}€.`,
    },
    coupon: {
      validateCoupon: 'Validera',
      couponCode: 'Kupongkod',
      couponApplied: 'Kupongen har tillämpats.',
      couponDiscount: 'Kupongrabatt',
      validationFailed: 'Valideringen misslyckades.',
      validation: {
        couponCodeInvalid: 'Ogiltig kupongkod.',
        couponExpired: 'Kupongen har gått ut.',
        invalidCamp: 'Kupongen gäller inte för vald campingplats.',
        usageLimitExceeded: 'Kupongens användningsgräns har överskridits.',
        customerNightsLimitExceeded: 'Kupongnätterna har överskridits.',
        customerRemainingNights: (...args: string[]) =>
          `Kupongen har ${args[0]} nätter kvar innan betalning.`,
      },
    },
    registration: {
      booking: 'Boka',
      of: 'av',
      header: 'Fyll i din kontaktinformation',
      subheader: 'Befintliga Best Park konto?',
      login: 'Logga in här',
      loginNote: 'Logga in här',
      firstName: 'Förnamn',
      lastName: 'Efternamn',
      phone: 'Telefon',
      phoneInfo: '(i internationellt format, e.g. +358401234567)',
      phoneLabel: 'Vänligen skriv in ditt telefonnummer',
      email: 'E-post',
      street: 'Gatuadress',
      postalCode: 'Postnummer',
      town: 'Stad',
      country: 'Land',
      license: 'Registreringsnummer',
      membershipCard1: 'SF Caravan',
      membershipCard2: 'C.C.I.',
      membershipNote:
        'Du måste visa upp det här kortet när du checkar in på lägret och det måste vara giltigt under hela din vistelse.',
      promos:
        'Jag skulle vilja få senaste nytt och erbjudanden från Best Park via e-post',
      marketing:
        'Registrera dig för vårt nyhetsbrev och få senaste erbjudanden och kuponger',
      newsletter:
        'Vi skickar ut ett nyhetsbrev ungefär en gång i månaden med relevanta erbjudanden för dig.',
      next: 'Nästa',
      errors: {
        fillRequired: 'Fyll i markerade fält',
        email: invalidEmail,
        name: 'Name is required.',
        licensePlate: 'License plate number is required.',
        phone:
          'Numret måste vara i internationellt format, till exempel +358401234567.',
        membership:
          'Medlemsnumret måste vara i formatet 123456-1 eller 1234567-1',
        emailExist: 'E-post är redan registrerad.',
        fieldRequired: 'Fältet är obligatoriskt',
        fieldTooLong: 'Fältvärdet är för långt',
      },
      clickHereToReserve: 'Klicka här för att starta din bokning',
    },
    parking: {
      header: 'Parking',
      subheader: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      noSlots: 'No parking slots available',
    },
    payment: {
      header: 'Din bokningssammanfattning',
      subheader: 'Välj betalningsmetod för att slutföra din bokning.',
      night: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'Nätter' : 'Natt'} i parken`,
      total: 'Totala',
      cardPay: 'Betala med kredit- och betalkort',
      mobilePay: 'Betala med mobila betalningar',
      collectorBankPay: 'Pay with installments',
      stripePay: 'Betala med Stripe',
      invoicePayment: 'Pay with invoice',
      invoiceNote: (...args: string[]) =>
        `billing surcharge ${args[0]} ${
          Number(args[0]) > 1 ? 'euros' : 'euro'
        }`,
      surcharge: 'Surcharge',
      onlineBankPay: 'Pay with online bank',
      coupon: 'Har du en kupongkod?',
      continueWithoutCoupon: 'Fortsätt utan kupongkod.',
      terms1: 'Jag har läst och förstått',
      terms2: 'villkoren.',
      terms3:
        'Vi kommer också att skapa ett konto för dig för enklare användning av dina Best Park inköp.',
      pay: (...args: string[]) => `Betala ${args[0]} nu`,
      processingPayment: 'Behandling av bokningsbetalning',
      paymentProcessed: 'Betalning har bearbetats.',
      paymentError:
        'Something went wrong! Our team will look into this. You may contact support.',
      paymentCancelled: 'Betalningen avbröts, försök igen.',
      priceDetails: 'Prisinformation',
      additionalGuests: 'Ytterligare gäster',
      discount: 'Any discount codes can be entered in the next screen.',
      goToPayment: 'Gå till betalning',
      to: 'till',
    },
    card: {
      goToReservation: 'Gå till bokning',
      days: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'Nätter' : 'Natt'}`,
    },
    profile: {
      header: 'Din bokning',
    },
    guestInformation: {
      passenger: 'passagerare',
      passengers: 'passagerare',
      header: 'Resandeanmälan',
      firstName: 'Förnamn',
      lastName: 'Efternamn',
      address: 'Adress',
      dateOfBirth: 'Födelsetid',
      nationality: 'Medborgarskap',
      passportNumber: 'Numret på pass',
      dateOfArrival: 'Ankomstdag',
      countryOfEntry: 'Det land från vilket resandena anländer till Finland',
      addChildButton: 'Lägg till familjemedlem',
      addPassenger: 'Lägg till ytterligare en passagerare',
      passengerInformation: 'Personuppgifter om resande',
      childSpouseInfo: 'Familjemedlemmen personliga uppgifter',
      passportInfo:
        'Ifylls inte av nordisk medborgare eller resande som är bosatt i Finland',
      companionHeader:
        'Personuppgifter för make eller maka och minderåriga barn som följer med resanden',
      subHeader:
        'Lämnande av falska personuppgifter är straffbelagt enligt strafflagen.',
      delete: 'Radera',
      campPassengerHeader: 'Ange passagerarinformation',
      campPassengerSubHeader:
        'Vi är lagligt skyldiga att begära denna information, förutsatt att felaktig personlig information är föremål för straff enligt strafflagstiftningen.',
      next: 'Nästa',
      completeData: 'Fullständiga personuppgifter krävs för varje passagerare.',
    },
    ancillary: {
      header: 'Ytterligare tjänster',
      skip: 'Hoppa över dessa',
      subheader1: 'Håll dig på resande fot medan parkerade!',
      subheader2: 'Vi har elektriska skotrar och cyklar i alla parker',
      subheader3: 'Begränsade be antal per park så boka din i förväg idag!',
      soldOut: 'Tyvärr slutsåld för alla dagar av din vistelse.',
      soldOutDay: (...args: string[]) =>
        `Alla ${args[0]} är reserverade för denna dag`,
      price: (...args: string[]) => `${args[0]}€ per dygn`,
      reservation: (...args: string[]) =>
        `Hur många ${args[0]} och vilka dagar behöver du dem för?`,
      max: (...args: string[]) => `Endast ${args[0]} tillgänglig för denna dag`,
      total: 'Totala:',
      totalService: (...args: string[]) =>
        `${args[0]} ${args[1]} on ${args[2]} ${
          parseInt(args[2]) > 1 ? 'Dagar' : 'Dygn'
        }`,
      firstDayNote: 'Bokningen börjar kl. 13:00 och slutar kl. 12:00 nästa dag',
      dayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
      lastDayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
    },
    details: {
      checkIn: 'Logga in',
      checkOut: 'Logga ut',
      startBooking: 'Börja boka',
      perNight: 'per natt',
      info:
        'Incheckningstiden börjar 13.00 varje dag och utcheckningstiden är vid middagstid',
      addOns: {
        earlyCheckIn: {
          info: ' Late Check in at 1PM',
          button: (...args: string[]) => `Lägg till för ${args[0]}€`,
        },
        lateCheckOut: {
          info: ' Sen utcheckning kl 15:00',
          button: (...args: string[]) => `Lägg till för ${args[0]}€`,
        },
      },
      parking: {
        title: 'Your Slot',
        slot: (...args: string[]) =>
          `When you arrive to the park your reserved slot is number ${args[0]}.`,
      },
      map: {
        button: 'Navigera till Parken',
      },
      general: {
        title: 'Porten öppnas',
        text:
          'När du anländer till parken, kan du öppna porten med denna personliga kod:',
        linkInfo: (...args: string[]) => `Visa information om ${args[0]}`,
        linkModify: 'Behöver du ändra eller avboka den här bokningen?',
        linkDownload: 'Ladda ner ditt kvitto',
        add: 'Lägg till',
      },
      services: {
        title: (...args: string[]) => `Din ${args[0]}`,
        text: (...args: string[]) =>
          `Det kommer att ha instruktioner här om var du kan plocka upp ${args[0]} du har reserverat.`,
      },
      cancelReservation: 'Avboka bokning',
      cancelledReservation: 'Bokning avbokad',
    },
    confirmation: {
      confirmed: 'Bokningen bekräftad',
      pending: 'Reservation väntar för närvarande.',
      confirmed_message: (...args: string[]) =>
        `Tack för din bokning, vi ser fram emot att se dig i ${args[0]}.`,
    },
    errors: {
      cancel: 'Du kan avboka bokningen 7 dagar före ankomst',
    },
    success: {
      cancel: 'Bokningen har avbokats.',
    },
    receipt: {
      invoice: (...args: string[]) => `Receipt #${args[0]}`,
      header: (...args: string[]) =>
        `Thank you for your payment for reservation ${args[0]}, it has been paid in full for the amount of ${args[1]}€`,
      details: {
        paymentDate: 'Payment date',
        contactEmail: 'Contact email',
        chargedTo: 'Charged to',
        forReservation: 'For reservation',
      },
      breakdown: {
        subtotal: 'Subtotal',
        grandTotal: 'Grand total',
        vat: (...args: string[]) => `VAT (${args[0] ?? 10}%)`,
      },
    },
    widget: {
      additionalGuests: 'Ytterligare gäster',
      from: 'Från',
      priceBreakdown: 'Price breakdown',
      night: 'natt',
      nights: (...args: string[]) =>
        `för ${args[0]} ${parseInt(args[0]) > 1 ? 'nätter' : 'natt'}`,
      total: 'Totala',
      inclusions: 'I priset per natt ingår:',
    },
    sendBookingRequest: {
      submit: 'Skicka bokningsförfrågan',
      success: 'Bokningsförfrågan har skickats framgångsrikt.',
      error: 'Misslyckades att skicka bokningsförfrågan.',
      disclaimer:
        'Jag förstår att detta inte är en bindande bokning för någondera parten. Efter att denna bokningsförfrågan har skickats kommer campingområdet att kontakta dig för att bekräfta tillgänglighet av en eventuell fordonsparkering.',
    },
  },
  promotions: {
    general: {
      read_more: 'Läs mer',
    },
    hotline: {
      title: 'Hjälptjänst 24/7',
      text: 'Vår kundtjänst är alltid tillgänglig',
      footer: 'The price of a call is 8,35 cent/call + 16,69 cent/minute',
    },
    infos: {
      title: 'Påverka!',
      text: 'Tips de bästa platserna och delta i presentkortdragningen.',
      buttonText: 'Till utfrågning',
    },
  },
  login: {
    header: 'Logga in på ditt konto',
    subheader: 'Inget konto ännu? ',
    registrationLink: 'Registrera dig här',
    forgetPasswordLink: 'Glömt lösenord?',
    email: 'E-Post',
    password: 'Lösenord',
    continue: 'Forsätta',
    authContent: 'Ge autentiseringskod skickad till ',
    editNumber: 'Redigera nummer',
    verify: 'Verifierings kod',
    sms: 'skickas via SMS',
    errors: {
      fillRequired: 'Fyll i markerade fält',
      email: 'E-post är ogiltigt',
      sessionInvalidated: 'Sessionen uplöpt, vänligen logga in igen',
      invalidCode: 'Ogiltig kod',
    },
    verifyRequired: 'Verification code is required',
    resendCode: 'återsänd koden',
    resending: 'skickar om...',
    next: 'Next',
  },
  mail: {
    header: 'Kolla din mobil',
    open: 'Öppna appen E-post',
    content: (...args: string[]) =>
      `Vi har skickat en inloggningslänk till ${args[0]} för att logga in dig.`,
  },
  registration: {
    header: 'Registrera ett konto',
    subheader: 'Befintliga Best Park konto? ',
    registerButton: 'Registrera',
    success: {
      header: 'Du har registrerat dig.',
      content: 'Du kan nu logga in på ditt konto.',
    },
  },
  profileEdit: {
    header: 'Redigera profilkonto',
    subheader: 'Uppdatera dina kontouppgifter',
    editButton: 'Redigera profil',
    success: {
      header: 'Du har uppdaterat ditt konto.',
      content: 'Kundkonto',
    },
  },
  calendar: {
    general: {
      start_reservation: 'Starta reservationen',
      select_check_in: 'Välj incheckningsdatum.',
      select_check_out: 'Välj utcheckningsdatum och klicka på starta bokning.',
      summary: (...args: string[]) =>
        `Reservation from ${args[0]} to ${args[1]}.\nCheck in at 13:00, check out at 12:00. Total price: ${args[2]}€.`,
    },
    months: {
      january: 'Januari',
      february: 'Februari',
      march: 'Mars',
      april: 'April',
      may: 'Maj',
      june: 'Juni',
      july: 'Juli',
      august: 'Augusti',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'December',
    },
    in_months: {
      january: 'Januari',
      february: 'Februari',
      march: 'Mars',
      april: 'April',
      may: 'Maj',
      june: 'Juni',
      july: 'Juli',
      august: 'Augusti',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'December',
    },
    weeks: {
      monday: 'Mån',
      tuesday: 'Tis',
      wednesday: 'Ons',
      thursday: 'Tor',
      friday: 'Fre',
      saturday: 'Lör',
      sunday: 'Sön',
    },
  },
  parks: {
    from: 'Från',
    check_advance: 'Check in advance',
    promotion: (...args: string[]) =>
      `Vi har ${args[0]} moderna parker för sommaren ${args[1]}`,
    per_night: 'per dygn',
    listTitle: (...args: string[]) => `Sommar ${args[0]} parken:`,
  },
  newsletter: {
    title: 'Beställ nyhetsbrev',
    subscribe: 'Beställ',
    subscribeMsg:
      'Prenumerera på vårt nyhetsbrev och bli först med att höra BestPark-nyheterna',
    notifications: {
      subscribeSuccess: 'Tack för att vi hör av dig!',
      subscribeError: 'Det gick inte att behandla din begäran. Försök igen.',
    },
  },
  mediaPage: {
    visualisation: 'Visuella bilder',
    stock: 'Illustrationer',
    parkImages: 'Presentation of the premises',
  },
  contactUs: {
    billingHeader: 'Fakturadetalj',
    businessId: 'Organisationsnummer',
    paymentTerm: 'Betalningsvillkor',
    paymentTermValue: (term: string) => `${term} days`,
    invoiceAddress: 'E-fakturaadress',
    brokerAddress: 'Förmedlarens adress',
    send: 'Skicka',
  },
  formLabels: {
    message: 'Ditt meddelande',
    name: 'Namn',
    email: 'E-post',
    phoneNumber: 'Telefon',
    place: 'Plats',
    authCode: 'Autentiseringskod',
  },
  amenities: {
    title: 'Bekvämligheter',
  },
  other: {
    title: 'Other Info',
    cancellationPolicy: 'Avbokningsregler',
    notes: 'Info',
  },
};

export default fi;
